import React, { useLayoutEffect } from "react";
import "../aseets/css/WhoWeAre.css";
import teamImg from "../aseets/gallery/gm-about3.jpg";

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Link } from "react-router-dom";

gsap.registerPlugin(ScrollTrigger);

const WhoWeAre = () => {
  useLayoutEffect(() => {
    const ctx = gsap.context(() => {

      /* ===============================
         MASTER TIMELINE – MAX REVEAL
      =============================== */
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: ".gm-who",
          start: "top 70%",
        },
      });

      // SECTION SCALE REVEAL
      tl.from(".gm-who-container", {
        scale: 0.95,
        opacity: 0,
        duration: 0.8,
        ease: "power3.out",
      });

      // TEXT STAGGER – STRONG REVEAL
      tl.from(
        ".gm-who-content > *",
        {
          y: 70,
          opacity: 0,
          duration: 0.8,
          stagger: 0.15,
          ease: "power4.out",
        },
        "-=0.4"
      );

      // IMAGE MASK + SLIDE
      tl.from(
        ".gm-who-image",
        {
          x: 120,
          scale: 1.08,
          opacity: 0,
          duration: 1.2,
          ease: "power4.out",
          clipPath: "inset(0 0 100% 0)",
        },
        "-=0.6"
      );

      /* ===============================
         IMAGE PARALLAX (DEPTH)
      =============================== */
      gsap.to(".gm-who-image", {
        y: -60,
        ease: "none",
        scrollTrigger: {
          trigger: ".gm-who",
          start: "top bottom",
          end: "bottom top",
          scrub: 1.2,
        },
      });

    });

    return () => ctx.revert();
  }, []);

  return (
    <section className="gm-who">
      <div className="gm-who-container">
        {/* LEFT */}
        <div className="gm-who-content">
          <span className="gm-who-eyebrow">WHO WE ARE</span>

          <h2 className="gm-who-title">
            Driving business growth through smart and impactful
            <span> digital marketing</span>
          </h2>

          <p className="gm-who-text">
            Founded with a vision to empower brands in the digital era,
            <strong> Global Manch</strong> is a growth-driven digital marketing
            company helping businesses scale through strategy, creativity,
            and technology.
          </p>

          <p className="gm-who-text">
            Our team brings together expertise across
            <strong>
              {" "}
              SEO, Social Media, Content Creation, Performance Marketing,
              and Web Development
            </strong>
            . We work collaboratively with one clear goal — delivering
            measurable, long-term results for our clients.
          </p>

          <Link to='/contact-us'><button className="gm-who-btn">Ready to Go Digital?</button></Link>
        </div>

        {/* RIGHT */}
        <div className="gm-who-image-wrap">
          <img
            src={teamImg}
            alt="Global Manch Team"
            className="gm-who-image"
          />
        </div>
      </div>
    </section>
  );
};

export default WhoWeAre;
